import { render, staticRenderFns } from "./SaleBonusList.vue?vue&type=template&id=5f15b30c&scoped=true"
import script from "./SaleBonusList.vue?vue&type=script&lang=js"
export * from "./SaleBonusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f15b30c",
  null
  
)

export default component.exports